import React from 'react';
import PersianNumber from 'packages/ui/PersianNumber';
import { Table } from '../../../routes/campaign/utils/table.style';

function EvandStatistics({ data }) {
  return (
    <Table>
      <thead>
        <tr>
          <th>آمار ایوندی</th>
          <th>تعداد</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <th>موفق‌</th>
          <td>
            <PersianNumber value={data.targeted_contacts_count} format />
          </td>
        </tr>

        <tr>
          <th>ناموفق‌</th>
          <td>
            <PersianNumber value={data.failed_targeted_contacts_count} format />
          </td>
        </tr>
      </tbody>
    </Table>
  );
}

export default EvandStatistics;
